import { render } from "./MenuHidingBehavior.vue?vue&type=template&id=6268fbf4"
import script from "./MenuHidingBehavior.vue?vue&type=script&lang=ts"
export * from "./MenuHidingBehavior.vue?vue&type=script&lang=ts"

import "./MenuHidingBehavior.vue?vue&type=style&index=0&id=6268fbf4&lang=css"
script.render = render

export default script